const defaultPlanRouteParams = {
    companyDomainId: ":companyDomainId",
    legalEntityId: ":legalEntityId",
    planId: ":planId",
    version: "v1",
};
export const buildPlanRouteUrl = (endpoint, options) => {
    const { companyDomainId, legalEntityId, planId, version } = {
        ...defaultPlanRouteParams,
        ...options,
    };
    return `/${version}/company-domain/${companyDomainId}/legal-entity/${legalEntityId}/plan/${planId}${endpoint}`;
};
